module.exports = __webpack_public_path__ + "watch_2.483a633c8b546087311dca7ad0474ce9.svg";